var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"over"}},[(_vm.visible)?_c('div',{staticClass:"transparent-overlay",style:({ backgroundColor: _vm.bgColor,top: _vm.fixedTop}),on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.handleClick.apply(null, arguments)}}},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }